import { useStateManager } from "@bcm-dev/bcms-vite";
import { TableBody, TableColumnContainer, TableColumnView, TableView } from "components/shared";
import React from "react";
import TASPositivePayCreateTemplateFileMappingPreviewTableRow from "../TASPositivePayCreateTemplateFileMappingPreviewTableRow";

import "./styles.css";

/**
 * @function TASPositivePayCreateTemplateFileMappingPreviewTable
 * @return {React.Component}
 * @exported true
 * @description The Import File Mapping Preview table for the ImportFileMappingPreviewWidget.
 */
export default function TASPositivePayCreateTemplateFileMappingPreviewTable(props) {
    const { ui, data } = useStateManager(); 
    const columns = data.selectedColumns;
    const fileRows = data.checkTemplateRows;
    const showFilePreview = ui.checkTemplate.showFilePreview;
    
    const columnsItems = columns.map(item => {
        var optionName = item.value.value.replace("(Required)","");

        // The column name is different for selection "Item Type Code".
        if(optionName === "Item Type Code") optionName = "Item Type Custom";
        
        return <TableColumnView key={item.id} className={`column-item ${item.value.class} text-left`} text={`${optionName}`} />
    }, []);

    const participantItems = fileRows.map(item => {
        return <TASPositivePayCreateTemplateFileMappingPreviewTableRow
        key={ item.id } data={ item } />
    }, []);

    return (
        <TableView className="tas-positive-pay-create-template-file-mapping-preview-table">
            <TableColumnContainer>
                {columnsItems}
            </TableColumnContainer>
            <TableBody>
                {showFilePreview.isActive && participantItems}
            </TableBody>
        </TableView>
    )
}
